<template>
  <e-dialog
    :dialogTitle="'所属分类'"
    :centerDialogVisible="classifyVisible"
    @updateVisible="classifyResetPopupData"
    @resetPopupData="classifyResetPopupData"
    @submitPopupData="classifySubmitPopupData"
    :popupWidth="'500px'"
    :destroyClose="true"
    :modalAppendToBody="false"
  >
    <el-input placeholder="输入关键字进行过滤" v-model="filterText"> </el-input>

    <div class="tree-box">
      <el-tree
        v-loading="loading"
        ref="tree"
        @check="handleCheck"
        :data="categoryTreeData"
        @check-change="handleCheckChange"
        show-checkbox
        highlight-current
        :props="defaultProps"
        :indent="30"
        :filter-node-method="filterTreeNode"
        :default-checked-keys="defaultCheckedKeys"
        :default-expanded-keys="defaultCheckedKeys"
        node-key="categoryId"
      >
        <template slot-scope="{ node, data }">
          <div style="width: 100%; display: flex">
            <span>{{ data.categoryName }}</span>
          </div>
        </template>
      </el-tree>
    </div>
  </e-dialog>
</template>

<script>
import api from '../../../../../api/product'
import eDialog from '@/modules/projectA/components/common/e-dialog'
export default {
  components: { eDialog },
  props: {
    classifyVisible: {
      type: Boolean,
      default: false
    },
    defaultCheckedKeys: {
      type: Array,
      default() {
        return []
      }
    },
    categoryTreeData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    },
    categoryTreeData(val) {
      console.log(val)
      this.loading = false
      // if (val.length) {
      //   this.loading = false
      // }
    }
  },
  data() {
    return {
      filterText: '',
      loading: true,
      checkNodes: [],
      checkNodes2: [],
      categoryId: null,
      defaultProps: {
        label: 'categoryName',
        isLeaf: 'leafFlag',
        children: 'children'
      },
      checkFlag: false,
      checkCategoryIdList: []
    }
  },

  methods: {
    // 关闭所属分类弹框
    classifyResetPopupData() {
      this.checkCategoryIdList = []
      this.$emit('resetPopupData')
    },

    // 所属分类确定
    classifySubmitPopupData() {
      let arr = this.removeRepetition([...this.checkNodes2, ...this.checkNodes])
      this.checkNodes2 = []
      this.checkNodes = []
      this.$emit('submitPopupData', arr)
    },

    //去重
    removeRepetition(arr) {
      let obj = {}
      arr = arr.reduce(function (item, next) {
        obj[next.categoryId] ? '' : (obj[next.categoryId] = true && item.push(next))
        return item
      }, [])
      return arr
    },

    handleCheckChange(data, flag) {
      if (flag) {
        this.checkNodes.push(data)
        this.checkNodes2.push(data)
      } else {
        this.checkNodes.forEach((item, index) => {
          if (item.categoryId == data.categoryId) {
            this.checkNodes.splice(index, 1)
          }
        })
        this.checkNodes2.forEach((item, index) => {
          if (item.categoryId == data.categoryId) {
            this.checkNodes.splice(index, 1)
          }
        })
      }
    },

    // 勾选树节点
    async handleCheck(data, nodes) {
      this.checkNodes2 = nodes.checkedNodes.filter((item) => item.leafFlag)
      if (!this.checkCategoryIdList.includes(data.categoryId)) {
        this.checkFlag = true
        this.checkCategoryIdList.push(data.categoryId)
        let node = this.$refs.tree.getNode(data.categoryId)
        // 设置未进行的懒加载状态
        node.loaded = false
        // 重新展开节点就会间接出发load达到刷新效果
        node.expand()
      }
    },

    filterTreeNode(value, data) {
      if (!value) return true
      return data.categoryName.indexOf(value) !== -1
    },

    loadChildren(node, resolve) {
      if (node.level === 0) {
        this.getCategoryTree(-1, resolve)
      } else {
        this.getCategoryTree(node.data.categoryId, resolve)
        // return resolve([]);
      }
    },
    // 查询平台分类
    async getCategoryTree(categoryId, resolve) {
      let res = await api.getCategoryTree({ categoryId })
      if (res.code == '200') {
        this.loading = false
        // res.data.forEach((item) =>
        //   item.categoryLevel == 1
        //     ? (item.disabled = true)
        //     : (item.disabled = false)
        // );
        resolve(res.data)
        if (this.checkFlag) {
          res.data.forEach((item) => {
            if (item.leafFlag) {
              this.checkNodes.push(item)
            }
          })

          this.checkFlag = false
          res.data.forEach((item) => {
            if (!item.leafFlag && !item.disabled) {
              this.checkFlag = true
              this.checkCategoryIdList.push(item.categoryId)
              let node = this.$refs.tree.getNode(item.categoryId)
              // 设置未进行的懒加载状态
              node.loaded = false
              // 重新展开节点就会间接出发load达到刷新效果
              node.expand()
            }
          })
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__footer {
  padding: 20px;
}
::v-deep .el-dialog__body {
  height: 312px;
  overflow-y: auto;
  padding-bottom: 0;
}
.tree-box {
  width: 100%;
  height: 250px;
  box-sizing: border-box;
  padding: 2px 0;
  overflow-y: auto;
  margin-top: 10px;
}
</style>
